var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_calendar",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24747",
    width: 17.2,
    height: 17.199,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24746",
    width: 17.2,
    height: 17.199,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24745",
    width: 15.889,
    height: 4.335,
    transform: "translate(0.656 1.708)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-634 -72)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 24,
    height: 24,
    transform: "translate(634 72)",
    fill: "#999",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(637 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_69",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_67",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_66",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_64",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_52",
    d: "M14.323,1.708H3.49A2.834,2.834,0,0,0,.656,4.541v1.5H16.544V3.93a2.222,2.222,0,0,0-2.221-2.222"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_53",
    d: "M8.6,8.355a1,1,0,1,1-1,1,1,1,0,0,1,1-1",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_54",
    d: "M4.6,8.355a1,1,0,1,1-1,1,1,1,0,0,1,1-1",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_55",
    d: "M4.6,12.355a1,1,0,1,1-1,1,1,1,0,0,1,1-1",
    fill: "#333",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_56",
    d: "M14.6,1.482H13.263V.6a.6.6,0,1,0-1.2,0v.882H5.137V.6a.6.6,0,1,0-1.2,0v.882H2.6A2.515,2.515,0,0,0,0,3.9V14.785A2.515,2.515,0,0,0,2.6,17.2h12a2.515,2.515,0,0,0,2.6-2.414V3.9a2.515,2.515,0,0,0-2.6-2.414m-12,1.2H3.937v.589a.6.6,0,1,0,1.2,0V2.682h6.926v.589a.6.6,0,1,0,1.2,0V2.682H14.6A1.319,1.319,0,0,1,16,3.9V5.275H1.2V3.9A1.319,1.319,0,0,1,2.6,2.682M14.6,16H2.6a1.319,1.319,0,0,1-1.4-1.215V6.475H16v8.31A1.319,1.319,0,0,1,14.6,16",
    fill: "#333"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.cbf55ce0ba18d9dc214bd03e36142ff7.svg";
export { ForwardRef as ReactComponent };